<template>
    <v-toolbar color="" fixed dark app class="customHeader" id="headerToolbar" :height="mapSearchScrollToOffset">
        <v-toolbar-title class="ml-0 sidebar">
            <v-toolbar-side-icon class="minimize-drawer-btn   hidden-lg-and-up" @click.stop="handleDrawerToggle"> <v-icon medium>menu</v-icon></v-toolbar-side-icon>
            <v-toolbar-side-icon class="toggle-drawer-btn  hidden-md-and-down" @click.stop="handleDrawerMinimize"> <v-icon medium>menu</v-icon></v-toolbar-side-icon>
        </v-toolbar-title>
        <router-link to="/dashboard" title="Loadmax" class="logoHdr">
            <img v-bind:src="computeLogo" height="36" alt="Load">
        </router-link>
        <v-spacer></v-spacer>
        <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
            <v-btn icon large flat :ripple="false" slot="activator"  href="https://loadmax.com/news" target="_blank" class=" hidden-sm-and-down custIcontop" @click="showDialogFn($event)">
                <v-icon medium>dashboard</v-icon>
            </v-btn>
        </v-menu>
        <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
            <v-btn icon large flat :ripple="false" slot="activator" href="https://forum.loadmax.com/" target="_blank" class=" hidden-sm-and-down custIcontop" @click="showDialogFn($event)">
                <v-icon medium>forum</v-icon>
            </v-btn>
        </v-menu>
        <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
            <v-btn icon large flat slot="activator" class="custIcontop">
                <v-icon medium>person</v-icon>
            </v-btn>

            <v-list class="pa-0 menutop">
                <v-list-tile v-for="(item,index) in items" :to="!item.href ? { name: item.name } : null" :href="item.href" @click="item.click(self)" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
                    <v-list-tile-action v-if="item.icon">
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-menu>
    
            <v-dialog v-model="changePasswordModal" persistent max-width="320"> 
                <v-card>
                    <v-toolbar color="orange" dark small>
                        <v-toolbar-title>Change Password</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn dark icon @click="hideChangePasswordModal">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-form @submit.prevent="changePassword()" autocomplete="off">
                    <v-card-text>
                        <input autocomplete="false" name="hidden" type="text" style="display:none;">
                        <v-layout row wrap>
                            <v-flex lg12 md12 xs12 pos-relative>
                            <v-text-field :type="'password'"
                                label="Current Password *"
                                class="white-placeholder"
                                autocomplete="off"
                                v-model="form.current_password"
                                id="current_password"
                                data-vv-name="current_password"
                                data-vv-as="Current Password"
                                placeholder
                                v-validate="{required:true}"
                                :error-messages="errors.collect('current_password')"
                            ></v-text-field>
                            <a class="forgot-password-link" @click="forgotPassword">Forgot Password?</a>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex lg12 md12 xs12>
                            <v-text-field :type="'password'"
                                label="New Password *"
                                class="white-placeholder"
                                autocomplete="off"
                                v-model="form.new_password"
                                id="new_password"
                                data-vv-name="new_password"
                                data-vv-as="New Password"
                                placeholder
                                v-validate="'required|min:8'" ref="new_password"
                                :error-messages="errors.collect('new_password')"
                            ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex lg12 md12 xs12>
                            <v-text-field
                            label="Confirm New Password *"
                            data-vv-name="password_confirmation"
                            data-vv-as="Confirm New Password"
                            data-vv-delay="300"
                            v-validate="'required|confirmed:new_password'"
                            v-model="form.confirm_new_password"
                            :error-messages="errors.collect('password_confirmation')"
                            :type="'password'"
                            ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="gray white--text" small @click="hideChangePasswordModal">
                            Cancel
                        </v-btn>
                        <v-btn color="green white--text" class="white-text" type="submit" small>
                            Submit
                        </v-btn>
                    </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
        
        
            <v-dialog v-model="forgotPasswordModal" persistent max-width="320">
                <v-card>
                    <v-toolbar color="orange" dark small>
                        <v-toolbar-title> Password</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        {{alertMsgForForgotPassword}}
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green white--text" class="white-text" small @click="hideforgotPasswordModal">
                            Ok
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="showDialog" persistent max-width="500px">
                <v-card>
                    <v-card-text>
                        {{maxTalkClickedMsg}}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green white--text" text @click="showDialog=false;utils.updateMaxTalkClicked()">
                            Ok
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
    
    </v-toolbar>
</template>

<script>
import Util from "@/util";
import {
    mapGetters,
    mapActions
} from "vuex";
import config from "../config";
import services from "../services/HttpService";
import utils from "../util/";
const AppToolbar = {
    name: "app-toolbar",
    components: {},
    data: () => ({
        self: null,
        expanded: true,
        rightDrawer: false,
        mapSearchScrollToOffset:config.mapSearchScrollToOffset,
        changePasswordModal: false,
        forgotPasswordModal: false,
        alertMsgForForgotPassword: config.alertMsgForForgotPassword,
        form: {
            current_password: '',
            new_password: '',
            confirm_new_password: ''
        },
        created() {
            AppEvents.forEach(item => {
                this.$on(item.name, item.callback);
            });
            window.getApp = this;
        },
        items: [{
                icon: "account_circle",
                title: "Profile",
                click: self => {
                    self.$router.push('/profile');
                }
            },
            {
                icon: "lock",
                title: "Change Password",
                click: self => {
                    self.changePasswordModal = true;
                    //self.$router.push('/change-password');
                }
            },
            {
                icon: "fullscreen_exit",
                title: "Logout",
                click: self => {
                    if (confirm("Are you sure you want to logout?")) {
                        self.logout();
                        let loginUrl = '/login';
                        if(self.$store.state.loginType && self.$store.state.loginType != ''){
                            loginUrl += '/'+self.$store.state.loginType;
                        }
                        self.$router.replace(loginUrl);
                    }
                }
            }
        ],
        showDialog:false,
        maxTalkClickedMsg:config.maxTalkClickedMsg
    }),
    mounted() {
        this.self = this;
    },
    created() {
        this.utils = utils;
        // var loc = window.location;
        // var uri = 'ws:';

        // if (loc.protocol === 'https:') {
        // uri = 'wss:';
        // }
        // uri += '//' + loc.host;
        // uri += loc.pathname + 'ws';
        // var uri = 'ws://10.10.16.22:8081/ws';
        // let ws = new WebSocket(uri)

        // ws.onopen = function() {
        // console.log('Connected')
        // }

        // ws.onmessage = function(evt) {
        //     var out = document.getElementById('output');
        //     console.log('evt.dataevt.data',evt.data)
        //     // out.innerHTML += evt.data + '<br>';
        // }

        // setInterval(function() {
        //     ws.send({key:'001', value:'Hello Server'});
        // }, 10000);
    },
    computed: {
        toolbarColor() {
            return this.$vuetify.options.extra.mainNav;
        },
        computeLogo() {
            return "/static/loadmaxlogo.png";
        }
    },
    methods: {
        ...mapActions([
            "logout"
        ]),
        handleDrawerToggle() {
            window.getApp.$emit("APP_DRAWER_TOGGLED");
        },
        handleDrawerMinimize() {
            window.getApp.$emit("APP_DRAWER_MINIMIZED");
        },
        handleFullScreen() {
            Util.toggleFullScreen();
        },
        openThemeSettings() {
            this.$vuetify.goTo(0);
            this.rightDrawer = !this.rightDrawer;
        },
        changePassword() {
            const self = this,
                wApp = window.getApp;
            self.$validator
                .validateAll()
                .then(isValid => {
                    if (isValid) {
                        self.changePasswordModal = false;
                        wApp.$emit("showLoader", {
                            show: true
                        });
                        services.post("users/changeUserPassword", {
                            password: self.form.new_password,
                            old_password: self.form.current_password
                        },{"Authorization": "Bearer " + self.$store.state.user.token})
                        .then(res => {
                            wApp.$emit("showLoader", {
                                show: false
                            });
                            self.changePasswordFormReset();
                            if (res.data.status) {
                                self._showToast(res.data.message);
                            } else {
                                self._showToast(res.data.message, config.errMsgColorStr);
                            }
                        })
                        .catch(err => {
                            self.changePasswordFormReset();
                            self._showToast(err.message, config.errMsgColorStr);
                        });
                    }
                })
                .catch(e => {
                    wApp.$emit("showLoader", {
                    show: false
                });
                return false;
            });
        },
        hideChangePasswordModal(){
            const self = this;
            self.changePasswordModal = false;
            self.changePasswordFormReset();
        },
        changePasswordFormReset(){
            const self = this;
            self.form.current_password = "";
            self.form.new_password = "";
            self.form.confirm_new_password = "";
            self.$validator.reset();
        },
        forgotPassword(){
            const self = this,
                wApp = window.getApp;
            self.changePasswordModal = false;
            wApp.$emit("showLoader", {
                show: true
            });
            services.post("users/forgotPassword", {
                "email": self.$store.state.user.email
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self.changePasswordFormReset();
                if (res.data.status) {
                    self.forgotPasswordModal = true;
                } else {
                    self._showToast(res.data.message, config.errMsgColorStr);
                }
            })
            .catch(err => {
                self.changePasswordFormReset();
                self._showToast(err.message, config.errMsgColorStr);
            });
        },
        hideforgotPasswordModal(){
            const self = this;
            self.forgotPasswordModal = false;
            self.$store.dispatch('logout');
            let loginUrl = '/login';
            if(self.$store.state.loginType && self.$store.state.loginType != ''){
                loginUrl += '/'+self.$store.state.loginType;
            }
            self.$router.push(loginUrl);
        },
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        showDialogFn(event){
            const self = this;
            if(self.$store.state.user.is_maxtalk_clicked == 0 && !self.$store.state.user.Issuperadmin){
                self.showDialog = true;
                event.preventDefault();
            }else{
                self.showDialog = false;
            }
        }
    }
};
export default AppToolbar;
</script>
<style lang="stylus">
.app--drawer.v-navigation-drawer--is-mobile 
    padding-top: 0 !important;
a.forgot-password-link
    text-decoration: none !important;
    position: absolute;
    right: 0;
    top: 22px;
    color: #ff812b !important;
    font-size: 12px !important;
</style>
</style>



// WEBPACK FOOTER //
// src/components/AppToolbar.vue